import type { IconifyIcon } from '@iconify/types';
import appleIcon from '@iconify/icons-mdi/apple';
import googleIcon from '@iconify/icons-mdi/google';
import microsoftIcon from '@iconify/icons-mdi/microsoft';
import yahooIcon from '@iconify/icons-mdi/yahoo';
import { FederatedProvider } from './federatedAuth';

/** Human-readable provider name used in button labels and copy. */
export const PROVIDER_LABELS: Record<FederatedProvider, string> = {
  google: 'Google',
  google_workspace: 'Google',
  yahoo: 'Yahoo',
  microsoft: 'Microsoft',
  apple: 'Apple',
};

/** Iconify icon data per provider (mdi set). */
export const PROVIDER_ICONS: Record<FederatedProvider, IconifyIcon> = {
  google: googleIcon,
  google_workspace: googleIcon,
  yahoo: yahooIcon,
  microsoft: microsoftIcon,
  apple: appleIcon,
};

export const providerLabel = (provider: FederatedProvider): string =>
  PROVIDER_LABELS[provider] ?? 'provider';
